/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { TextField, makeStyles } from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import { useDebounce } from "lib/react/customHooks";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
}));

export default function FiltersSearchBoxComponent({ handleChange }) {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearchTerm = useDebounce(searchTerm, 200);

  useEffect(() => {
    handleChange({ searchTerm: debouncedSearchTerm });
  }, [debouncedSearchTerm]);

  return (
    <TextField
      id="search-box"
      size="small"
      label="Search"
      variant="outlined"
      value={searchTerm}
      className={classes.root}
      onChange={(event) => setSearchTerm(event.target.value)}
      InputProps={{
        endAdornment: <Search />,
      }}
    />
  );
}
